module.exports = __webpack_public_path__ + "static/media/img_top_gift@3x.1642e2c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@3x/img_top_gift@3x.png
// module id = 786
// module chunks = 0